import * as React from 'react';
import { useSelector } from 'react-redux';

import { ResidentialNativeTGBBanner } from './ResidentialNativeTGBBanner';
import { TGSimplifieldBannerWrapper } from './TGSimplifieldBannerWrapper';
import { getJsonQuery } from '../../../../../../selectors/getJsonQuery';
import { TgbNativedescGeneralContext } from '../../../../../../types/adfox';

export interface INativeTGBBannerContainerProps {
  context: TgbNativedescGeneralContext;
  campaignId: string;
  bannerId: string;
}

export function NativeTGBBannerContainer(props: INativeTGBBannerContainerProps) {
  const { context, campaignId, bannerId } = props;

  const jsonQuery = useSelector(getJsonQuery);

  const locationId = React.useMemo(() => jsonQuery.region && jsonQuery.region.value[0], [jsonQuery]);

  return (
    <TGSimplifieldBannerWrapper>
      <ResidentialNativeTGBBanner
        campaignId={campaignId}
        context={context}
        locationId={locationId}
        bannerId={bannerId}
      />
    </TGSimplifieldBannerWrapper>
  );
}
